import { createSvgIcon } from '@mui/material/utils';

const Check = createSvgIcon(
    <svg viewBox="0 -960 960 960">
        <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
    </svg>,
    'Check'
);

export { Check };
